// extracted by mini-css-extract-plugin
export var currencyInput = "_k8-1";
export var currencySymbol = "_k8-0";